<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select v-model="params.storeid" placeholder="门店选择" @change="storeChange" style="width: 120px;">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标签" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select size="mini" v-model="params.tags" collapse-tags style="width: 120px" clearable @change="tagChange">
                    <el-option v-for="(item,key) in dynamicTags" :value="item.tagid" :label="item.tagname" :key="key"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table height="calc(100% - 5.6rem)" ref="table" :data="bigCardCheckDetal" show-header style="width: 100%" show-summary :summary-method="getSummaries" >
            <el-table-column prop="membername" align="center" label="姓名">
                <template slot-scope="scope">
                    {{scope.row.membername}}({{scope.row.number}})
                </template>
            </el-table-column>
            <el-table-column prop="staffname" align="center" label="员工姓名"></el-table-column>
            <el-table-column prop="lastdate" align="center" label="最后到店">
                <template slot-scope="scope">
                    {{$moment(scope.row.lastdate).format('MM-DD')}}({{scope.row.days}})
                </template>
            </el-table-column>
            <el-table-column prop="avgday" align="center" label="预约/亮灯">
                <template slot-scope="scope">
                    <el-button type="success" icon="el-icon-s-opportunity" size="mini" v-if="scope.row.days<=7*0.7" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="warning" icon="el-icon-s-opportunity" size="mini" v-else-if="scope.row.days<=7" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="danger" icon="el-icon-s-opportunity" size="mini"  v-else circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dynamicTags:[],
                bigCardCheckDetal:[],
                params:{
                    storeid:localStorage.getItem("storeid"),
                    fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                    todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
                    tags:1,
                    type:2,
                },
                brands:[],
            }
        },
        created: function () {
            this.getTagLibrary();
            this.getBigCardInfo();
            this.getStoreInfoByStructsOpen();
        },
        updated() {
            this.$nextTick(() => {
                this.$refs['table'].doLayout();
            });
        },
        methods:{
            tagChange(){
                this.getBigCardInfo();
            },
            getSummaries(param){
                const {columns, data} = param;
                const sums = [];
                let number=0;
                let count=0;
                for(let val of data){
                    number=number+val.number;
                    if(val.number>0){
                        count++;
                    }
                }
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    else if(index==1){
                        sums[index] = '总人数'+count;
                    }
                    else if(index==2){
                        sums[index] = '总次数'+number;
                    }
                });
                return sums;
            },
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.params.storeid=val;
                this.getBigCardInfo();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getTagLibrary(){
                this.$post("basis/getTagLibrary",{storeid:this.params.storeid}).then(res=>{
                    if(res.sucess){
                        this.dynamicTags=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBigCardInfo(){
                if(this.params.storeid=="320c07ba76e94b0d8735aefe4470c07a"){
                    this.bigCardCheckDetal=[];
                    return;
                }
                this.$postw("beautymanager/getBigCardInfo",this.params).then(res=>{
                    if(res.sucess){
                        this.bigCardCheckDetal=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/beauty/bigcard.vue